/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import { createBEM } from 'src/util/bem';
import './stationSider.less';
import Input from 'src/types/iview/Input';
import StationTree from 'src/components/stationTree/stationTree';
import FrameSideBg from 'src/pages/layout/components/frameSideBg';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import EnumStationType from 'src/enums/enumStationType';
import EnumWarningNotice from 'src/enums/enumWarningNotice';
import EnumControlLevel from 'src/enums/enumControlLevel';
import EnumWaterLever from 'src/enums/enumWaterLever';
import Bus, { Events } from 'src/util/bus';
import Switch from 'src/types/iview/Switch';
import StationDetailApi from '../api/stationDetailApi';
import {DateTimeUtil} from "src/util/dateTimeUtil"
let bem = createBEM('gis-sider');

export interface StationSiderProps {
    mn?: string;
    id?: number;
    defaultSelect?: boolean;
    showCheckBox?: boolean
    value?: string
}

@Component
export default class StationSider extends Vue.Component<StationSiderProps> {
    @Prop({
        type: String,
    })
    mn!: string;

    @Prop({
        type: String,
    })
    value!: string;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: Boolean,
    })
    defaultSelect!: boolean;

    @Prop({
        type: Boolean,
    })
    showCheckBox!: boolean;

    // 是否带啊污染源站点列表
    contaminate: boolean = true;
    // 是否打开地表水站点
    surface: boolean = false;

    stationName: string = '';
    confirmStationName: string = '';
    get currentStation(): StationListDOI.RowDataI {
        return this.$store.state.stationDetail.currentStation;
    }
    clearCheckedNode() {
        (this.$refs.stationTree as StationTree).clearCheckedNode();
    }
    getStations() {
        return (this.$refs.stationTree as StationTree).getStations();
    }
    async mounted() {
        if (this.mn) {
            let data = await (this.$refs.stationTree as StationTree).getStationDetailByMN(this.mn);
            this.$store.commit('stationDetail/saveCurrentStation', data);
        } else if (this.defaultSelect) {
            let data = await (this.$refs.stationTree as StationTree).getStations();
            this.$store.commit('stationDetail/saveCurrentStation', data[0]);
            this.$emit('input', data[0].mn)
            Bus.$emit(Events.StationChange, data[0]);
        }
    }
    async changeAlarm(open) {
        let status = open ? EnumWarningNotice.Open.getId() : EnumWarningNotice.Close.getId();
        const stationId = this.id !== undefined && this.id !== null ? this.id : this.currentStation.id;
        if (stationId === undefined || stationId === null) {
            return;
        }
        StationDetailApi.changeAlarmNotice(stationId, status);
    }
    async openNodeByMn(mn: string) {
        if(!mn) {
            return
        }
        (this.$refs.stationTree as StationTree).openNodeByMn(mn);
    }
    render(h) {
        let {
            type,
            is_warning_notice,
            district_name,
            city_name,
            province_name,
            section,
            name,
            address,
            control_hierarchy,
            water_level,
            built_time,
            reception_time,
        } = this.currentStation;
        return (
            <FrameSideBg style="height: 100%">
                <div class={bem()}>
                    <div class={bem('search-input')}>
                        <Input
                            icon="ios-search"
                            placeholder="搜索站点名称"
                            style="width: auto"
                            v-model={this.stationName}
                            on-on-click={() => {
                                this.confirmStationName = this.stationName;
                            }}
                            on-on-keypress={e => {
                                e.keyCode === 13 && (this.confirmStationName = this.stationName);
                            }}
                        />
                        <div
                            class={bem('search-clear')}
                            on-click={() => {
                                this.stationName = '';
                                this.confirmStationName = '';
                            }}
                        >
                            重置
                        </div>
                    </div>
                    <row class={bem('station-info')} gutter={10} v-if={!this.showCheckBox}>
                        <i-col span="12">
                            站点类型：<span style="color: #EFFB29">{type === EnumStationType.Water.getId() ? '地表水' : type === EnumStationType.Pollution.getId() ?
                            '污染源': '地下水'}</span>
                        </i-col>
                        <i-col span="12">
                            水质等级：<span style="color: #02FB71">{EnumWaterLever.findId(water_level).getName()}</span>
                        </i-col>
                        <i-col span="12">
                            站点名称：<span style="color: #36ADFE">{name}</span>
                            {/* 站点名称：{' '} */}
                            {/* <span style="color: #36ADFE" title={type === EnumStationType.Water.getId() ? name : section}>
                                {type === EnumStationType.Pollution.getId() ? name : section}
                            </span> */}
                        </i-col>
                        <i-col span="12">
                            控制等级：<span style="color: #FC930B">{EnumControlLevel.findId(control_hierarchy).getName()}</span>
                        </i-col>
                        <i-col span="12">
                            警报通知：
                            {/* <Switch v-model={is_warning_notice}></Switch> */}
                            <Switch
                                size="large"
                                value={is_warning_notice === EnumWarningNotice.Open.getId()}
                                on-on-change={this.changeAlarm.bind(this)}
                            >
                                <span slot="open">ON</span>
                                <span slot="close">OFF</span>
                            </Switch>
                            {/* <span style="color: #36ADFE">{EnumWarningNotice.findId(is_warning_notice).getName()}</span> */}
                        </i-col>
                        <i-col span="12">
                            区域：<span title={province_name ? province_name + city_name + district_name : ''}>
                                {province_name ? province_name + city_name + district_name : ''}
                            </span>
                        </i-col>
                        <i-col span="24">
                            地址：<span title={address}>{address}</span>
                        </i-col>
                        <i-col span="24">
                            建立时间：<span title={built_time}>{DateTimeUtil.GMTToStr(built_time)}</span>
                        </i-col>
                        <i-col span="24">
                            验收时间：<span title={reception_time}>{DateTimeUtil.GMTToStr(reception_time)}</span>
                        </i-col>
                        <div class="text-center">
                            <img src={require('../../../assets/images/list-split.png')} alt="" />
                        </div>
                    </row>
                    <div class={[bem('station-tree')]}>
                        <StationTree
                            ref="stationTree"
                            stationName={this.confirmStationName}
                            value={this.value||this.currentStation.mn}
                            showCheckBox={this.showCheckBox}
                            on-input={v =>  this.$emit('input',v)}
                            on-check-change={(mns, stations)=> this.$emit('check-change',mns, stations)}
                            on-click={data => {
                                this.$emit('click', data);
                                Bus.$emit(Events.StationChange, data);
                                this.$store.commit('stationDetail/saveCurrentStation', data);
                            }}
                        />
                    </div>
                </div>
            </FrameSideBg>
        );
    }
}
